module.exports = __webpack_public_path__ + "static/media/last-added-cars-mini-blurred.d7744713.png";